import React from 'react';

import DropdownField from '@components/Form/DropdownField';
import FieldError from '@components/Form/FieldError';
import { DAYS, MONTHS, YEARS } from '@utils/dates';

interface DateOfBirthFieldProps {
  disableDobInput: boolean;
  error?: string;
}

const DateOfBirthField = ({ error, disableDobInput }: DateOfBirthFieldProps) => {
  return (
    <>
      <div className="dob-container flex items-center justify-between gap-6">
        <div className="w-5/12">
          <DropdownField
            name="month"
            options={MONTHS}
            placeholder="Month"
            isDisabled={disableDobInput}
          />
        </div>
        <div className="w-3/12">
          <DropdownField name="day" options={DAYS} placeholder="Day" isDisabled={disableDobInput} />
        </div>
        <div className="w-4/12">
          <DropdownField
            name="year"
            options={YEARS}
            placeholder="Year"
            isDisabled={disableDobInput}
          />
        </div>
      </div>
      {error && <FieldError>{error}</FieldError>}
    </>
  );
};

export default DateOfBirthField;
